export const BoostBackground = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1440"
    height="580"
    viewBox="0 0 1440 580"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.5" filter="url(#filter0_f_7097_170338)">
      <path
        d="M672.468 198.008C733.462 212.799 858.782 116.926 918.24 63.3362C921.291 60.5863 924.688 58.3983 928.594 57.1271C1079.79 7.91423 1440.05 225.505 1415.84 343.329C1391.31 462.682 410.053 473.668 427.963 416.738C445.872 359.809 35.8972 379.784 23.4383 343.329C10.9795 306.874 82.618 286.399 116.491 260.431C150.363 234.463 367.615 271.417 422.512 198.008C477.409 124.598 594.211 179.031 672.468 198.008Z"
        fill="#161616"
      />
      <path
        d="M672.468 198.008C733.462 212.799 858.782 116.926 918.24 63.3362C921.291 60.5863 924.688 58.3983 928.594 57.1271C1079.79 7.91423 1440.05 225.505 1415.84 343.329C1391.31 462.682 410.053 473.668 427.963 416.738C445.872 359.809 35.8972 379.784 23.4383 343.329C10.9795 306.874 82.618 286.399 116.491 260.431C150.363 234.463 367.615 271.417 422.512 198.008C477.409 124.598 594.211 179.031 672.468 198.008Z"
        fill="url(#paint0_radial_7097_170338)"
        fillOpacity="0.18"
      />
      <path
        d="M672.468 198.008C733.462 212.799 858.782 116.926 918.24 63.3362C921.291 60.5863 924.688 58.3983 928.594 57.1271C1079.79 7.91423 1440.05 225.505 1415.84 343.329C1391.31 462.682 410.053 473.668 427.963 416.738C445.872 359.809 35.8972 379.784 23.4383 343.329C10.9795 306.874 82.618 286.399 116.491 260.431C150.363 234.463 367.615 271.417 422.512 198.008C477.409 124.598 594.211 179.031 672.468 198.008Z"
        fill="url(#paint1_radial_7097_170338)"
        fillOpacity="0.18"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7097_170338"
        x="-107.6"
        y="-79.6"
        width="1654.2"
        height="659.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="64.8" result="effect1_foregroundBlur_7097_170338" />
      </filter>
      <radialGradient
        id="paint0_radial_7097_170338"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(514.295 10.7713) rotate(90) scale(408.258 907.67)"
      >
        <stop stopColor="#FF33AF" />
        <stop offset="1" stopColor="#FF33AF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_7097_170338"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(514.295 654.297) rotate(-90) scale(442.856 984.591)"
      >
        <stop stopColor="#C9A8FF" />
        <stop offset="1" stopColor="#C9A8FF" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
